/**
 * Matching lines AGAIN under the current scope (Akhil, 2026-09-21).
 *
 * The matcher's answer depends on the enquiry's company and type (`itemScope.ts`); change either
 * and the items already on the lines were chosen under the old scope. `rematchPlan` takes fresh
 * answers and says which lines move: a line whose new top hit is the item it already has is left
 * untouched, and a line the matcher found nothing for keeps its item — a re-match never blanks
 * a line. `from` is what the line had, for the toast.
 */
import type { ItemMatch } from './searchMatch'
import type { EnquiryItem } from './types'

export interface RematchAction {
  lineId: string
  itemCode: string
  score: number
  from: string | null
}

export function rematchPlan(
  lines: readonly EnquiryItem[],
  freshMatchFor: (line: EnquiryItem) => ItemMatch | null,
  only?: ReadonlySet<string>,
): RematchAction[] {
  const plan: RematchAction[] = []
  for (const line of lines) {
    if (only && !only.has(line.line_id)) continue
    const best = freshMatchFor(line)?.candidates[0]
    if (!best || best.item_code === line.item_code) continue
    plan.push({ lineId: line.line_id, itemCode: best.item_code, score: best.score, from: line.item_code })
  }
  return plan
}
